/// <reference path="../_references.ts"/>

module App.Utils {
	interface Scope extends ng.IScope {
		active: boolean;
		closeable: boolean;
		title: string;
		slideDirection: 'right' | 'left';
		toggleActive: () => void;
		isSlideLeft: () => boolean;
		onOpen?: () => void;
	}

	export class SlideOutDirective {
		public link: (scope: Scope, elem: ng.IAugmentedJQuery) => void;
		public scope = {
			active: '=',
			title: '@',
			slideDirection: '@',
			closeable: '<',
			onOpen: '&'
		};
		public replace = true;
		public transclude = true;
		public templateUrl = 'html/utils/slide-out.directive.html';

		constructor(private $timeout: ng.ITimeoutService) {
			SlideOutDirective.prototype.link = (scope, elem) => {
				scope.closeable = scope.closeable !== false;

				const overlay = angular.element('<div class="slide-out-overlay' + (scope.closeable ? '' : ' over') + '"></div>');

				overlay.on('click', () => {
					scope.toggleActive();
					scope.$apply();
				});

				elem.after(overlay);

				scope.toggleActive = () => {
					if (scope.closeable) {
						scope.active = !scope.active;
					}
				};

				scope.isSlideLeft = () => {
					return scope.slideDirection === 'left';
				};

				scope.$watch(() => scope.active, (newValue: boolean) => {
					if(newValue) {
						overlay.addClass('active');
						if (scope.onOpen) {
							scope.onOpen();
						}
					} else if(!newValue) {
						overlay.removeClass('active');
					}
				});

				$timeout(() => {
					elem.css('visibility', 'visible');
				}, 1000);
			};
		}

		public static Factory() {
            let instance = ($timeout: ng.ITimeoutService) => {
                return new SlideOutDirective($timeout);
            };

            return instance;
        }
	}
}